import { render } from "./Gallery.vue?vue&type=template&id=4d243bba&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=4d243bba&scoped=true&lang=css"

import exportComponent from "/builds/alex-yonge-photography/alex-yonge-photographs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d243bba"]])

export default __exports__